import { isUser, User } from "../models";
import { BaseController } from "./baseController";

const SettingsController = "/MVC/Settings";
const AccountController = "/MVC/Account";

export class UserInfoApi {
	static GetSettings = BaseController.GetFn(SettingsController);
	static PostAccount = BaseController.PostFn(AccountController);

	/**
	 * Retrieve info on logged in user from the controller
	 */
	public static async getUserInfo() {
		const userInfo = await UserInfoApi.GetSettings<User>("GetUserInfo");
		if (isUser(userInfo)) return userInfo;
		return null;
	}

	public static async login(username: string, password: string) {
		const timeZoneOffset = new Date().getTimezoneOffset();

		return await UserInfoApi.PostAccount<LoginResponse>("Login", { username, password, timeZoneOffset });
	}
}

interface LoginResponse {
	message: string;
	success: boolean;
}
